var vskoPassword = angular.module('vskoPassword', []);

vskoPassword.directive('vskoPassword', [function() {
  return {
    restrict: 'E',
    template: require('./vsko-password.html'),
    required: ['ngModel'],
    scope: {
      ngModel: '=',
      ngRequired: '=',
      ngDisabled: '='
    },
    controller: ['$scope', function($scope) {
      $scope.$watch('ngModel', function(newValue, oldValue) {
        $scope.passwordStrength = $scope.getPasswordStrengthness(newValue);
      });

      $scope.getPasswordStrengthness = function(password) {
        return password ? (password.length > 10 ? 'strong' : 'weak') : '';
      }
    }],
  }
}]);
